import React from 'react';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXTextModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXTextModalWrapper';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const Layout = () => {
  const { modalResource, loadModalCollectionByLink } = useModalContext();
  return (
    <PXTextModalWrapper
      additionalActions={modalResource.withRelationship(
        fr.relationships.skip.name,
        (rel) => (
          <FDSecondaryActionButton
            {...dataAttrs('skip-liabilities-btn', modalResource)}
            label={rel.meta('prompt')}
            onClick={() => loadModalCollectionByLink(rel.link('related').url())}
          />
        ),
        () => null,
      )}
    >
      <MetaControlField attr={'description'} />
    </PXTextModalWrapper>
  );
};

export default Layout;
